import { Box, Typography } from '@mui/material';
import { colors } from '@/theme';

export default function ListIcon({ content }): JSX.Element {
  return (
    <Box
      sx={{
        backgroundColor: colors.primary.main,
        borderRadius: '50px',
        width: '24px',
        height: '24px',
        minWidth: '24px',
        minHeight: '24px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: colors.common.white,
      }}
    >
      <Typography variant="body2" sx={{ color: colors.common.white }}>
        {content}
      </Typography>
    </Box>
  );
}
